/**
 * ===== How it works? ======
 * When [data-dynamic-links] link is clicked,
 * it load the url via ajax, and get its content to current page to behave like single-page-application.
 *
 * After everything is done, it will call initDynamicContent() method if it exists.
 * So use it as callback and do your javascript work there.
 * If you need to initialize any jquery component, do it in initDynamicContent() function.
 *
 * Use Lagina.reloadDynamicContent() method to refresh the page.
 */
export const dynamicContentMixin = {
  mounted() {
    $(function () {
      $("#dynamic-content-wrapper").on("click", "[data-dynamic-links] a", function (e) {
        e.preventDefault();
        const url = $(this).attr("href");
        Lagina.loadDynamicContent(url);
      });

      // [data-dynamic-links] clicked
      $(window).on("popstate", function () {
        if (!history.state
          || !history.state.url
          || history.state.url === window.location.href
          || history.state.url === location.href.replace(/https?:/i, "")
        ) {
          return;
        }
        window.location = history.state.url;
      });
    });
  },

  methods: {
    /**
     * Load given URL into #dynamic-content via Ajax.
     */
    loadDynamicContent(url) {
      const oldContent = $("#dynamic-content-wrapper").html();

      $(window).trigger('dynamic-content:before-load', [oldContent, url]);

      $("#dynamic-content").load(url + " #dynamic-content-wrapper", function (response) {
        window.history.replaceState({
          html: oldContent,
          url: window.location.href
        }, document.title, window.location.href);

        window.history.pushState({
          html: $(response).find("#dynamic-content-wrapper").html(),
          url: url
        }, response.pageTitle, url);

        if (typeof window.initDynamicContent == 'function') {
          // noinspection JSUnresolvedFunction
          window.initDynamicContent(response, oldContent, url);
        }

        $(window).trigger('dynamic-content:loaded', [response, oldContent, url]);
      });
    },

    /**
     * Refresh current page.
     */
    reloadDynamicContent() {
      Lagina.loadDynamicContent(window.location.href);
    },
  }
};
